import {
  FETCH_PREFECTURES_REQUEST,
  FETCH_STATIONS_REQUEST,
  FETCH_FACILITIES_REQUEST,
  FETCH_LOCATION_DETAIL_REQUEST,
} from './types'
import { takeLatest, take, select, fork } from 'redux-saga/effects'
import {
  fetchPrefecturesSaga,
  fetchStationsSaga,
  fetchFacilitiesSaga,
  fetchLocationDetailSaga,
} from './sagas'

let prefecturesRequestTask = null
let prefecturesLoaded = false

export function* watchPrefecturesSaga() {
  while (true) {
    yield take(FETCH_PREFECTURES_REQUEST)

    // 既にロード済みまたは実行中の場合はスキップ
    if (prefecturesLoaded || prefecturesRequestTask) {
      continue
    }

    try {
      // データが既に存在するかチェック
      const state = yield select()
      const hasData =
        state.prefectures?.data?.result &&
        Array.isArray(state.prefectures.data.result) &&
        state.prefectures.data.result.some(
          (area) => area.prefectures && area.prefectures.length > 0
        )

      if (hasData) {
        prefecturesLoaded = true
        continue
      }

      // 実行中のタスクをセット
      prefecturesRequestTask = yield fork(fetchPrefecturesSaga)
      yield prefecturesRequestTask
      prefecturesLoaded = true
    } catch (error) {
      // エラーの場合はリトライ可能にする
      prefecturesLoaded = false
    } finally {
      prefecturesRequestTask = null
    }
  }
}

export function* watchStationsSaga() {
  yield takeLatest(FETCH_STATIONS_REQUEST, fetchStationsSaga)
}

export function* watchFacilitiesSaga() {
  yield takeLatest(FETCH_FACILITIES_REQUEST, fetchFacilitiesSaga)
}

export function* watchLocationDetailSaga() {
  yield takeLatest(FETCH_LOCATION_DETAIL_REQUEST, fetchLocationDetailSaga)
}
